import { useLocation } from "react-router-dom";

import { Montage } from "./features/client/Montage";
import { Moderation } from "./features/moderator/Moderation";
import { MyTasks } from "./features/editor/MyTasks";
import { Takes } from "./features/takes/Takes";
import { Work } from "./features/work/Work";
import { Videos } from "./features/videos/Videos";
import { MontageRoot, MontageToaster } from "./MontageRoot";
import { MONTAGE_PATHS } from "./store";

/** «Монтаж» постановщика: доска и календарь отдела — два адреса одного раздела. */
export function MontagePage() {
  const { pathname } = useLocation();
  return (
    <MontageRoot expect="client">
      <Montage view={pathname.startsWith(MONTAGE_PATHS.clientCalendar) ? "calendar" : "board"} />
    </MontageRoot>
  );
}

/**
 * «Модерация»: очередь роликов и ничего больше.
 *
 * Не доска отдела, как было: модератор видит только проекты, на которые его
 * назначили, и в них — только то, что ему надо посмотреть. Планирование,
 * дедлайны и загрузка монтажёров к его работе отношения не имеют.
 */
export function ModerationPage() {
  return (
    <MontageRoot expect="moderator">
      <Moderation />
    </MontageRoot>
  );
}

/**
 * «Видео»: что сделали люди и как вышло. Один экран на три роли — монтажёру
 * свои, контент-мейкеру группа, руководителю отдел; отбор делает сервер.
 */
export function VideosPage() {
  return (
    <MontageRoot expect="people">
      <Videos />
    </MontageRoot>
  );
}

/** «Мои задачи» монтажёра. */
export function MyTasksPage() {
  const { pathname } = useLocation();
  return (
    <MontageRoot expect="editor">
      <MyTasks view={pathname.startsWith(MONTAGE_PATHS.editorCalendar) ? "calendar" : pathname.startsWith(MONTAGE_PATHS.editorPosts) ? "posts" : "tasks"} />
    </MontageRoot>
  );
}

/**
 * «Ролики B2G»: вышедшие ролики другого отдела для того, кто разносит их по
 * пабликам. Без MontageRoot: у раздающего нет роли в «Монтаже», и грузить
 * людей, доску и задачи ему незачем — экран живёт своим запросом.
 */
export function TakesPage() {
  return (
    <div className="-mx-4 px-4 md:-mx-6 md:px-6">
      <div className="montage-root min-h-[calc(100svh-8rem)] pb-[max(1rem,env(safe-area-inset-bottom))]">
        <Takes />
      </div>
      <MontageToaster />
    </div>
  );
}

/**
 * «Отработано»: раздающий (Саяна) отмечает, что сделал, — руководитель видит
 * отчёт. Как «Ролики B2G», без MontageRoot: экран живёт своим запросом.
 */
export function WorkPage() {
  return (
    <div className="-mx-4 px-4 md:-mx-6 md:px-6">
      <div className="montage-root min-h-[calc(100svh-8rem)] pb-[max(1rem,env(safe-area-inset-bottom))]">
        <Work />
      </div>
      <MontageToaster />
    </div>
  );
}
